import React from 'react'
import { Box, Flex, Link, Text } from 'components/ds'
import Instruction from '../instruction'
import Warning from '../warning'
type Props = {
  onDismiss: () => void
}

/**
 * SamlDisabled component for displaying SSO unavailability message
 *
 * Shows a warning message when SSO is not supported for certain operations
 * like saving files from external sites. Provides a way to go back to regular login.
 *
 * @param props - Component props
 * @param props.onDismiss - Callback function to dismiss the SSO form and return to login
 * @returns JSX element displaying the SSO disabled message
 */
const SamlDisabled = ({ onDismiss }: Props): React.ReactElement<'div'> => (
  <div>
    <Instruction text="SSO Sign in" />
    <Box>
      <Warning>
        SSO is not currently supported for
        <br /> saving files from external sites.
      </Warning>

      <Flex direction="column" gap="2" mt="2">
        <Text align="center" size="2">
          <Link
            href="#"
            onClick={e => {
              e.preventDefault()
              onDismiss()
            }}
          >
            Back to Sign in
          </Link>
        </Text>
      </Flex>
    </Box>
  </div>
)

export default SamlDisabled
